/**
 * Textos da conferência das etapas (E147.F3, GUS-180, ADR-0101; E153.F1, ADR-0104): as oito etapas da raia eletrônica,
 * o que cada critério confere, o motivo da etapa aguardando, a condição de saída da que não liberou e
 * as saídas da equipe para a consulta do sistema indisponível. A conferência diz se a etapa executou
 * sobre o material certo; não é a conclusão do exame, e nada aqui é pedido ao cliente.
 */
export const ptBREtapas = {
  titulo: 'Conferência das etapas',
  carregando: 'Carregando a conferência das etapas…',
  erro: 'Não foi possível carregar a conferência das etapas. Tente novamente.',
  semPermissao: 'A conferência das etapas é da equipe que atende o caso.',
  tentarDeNovo: 'Tentar de novo',
  naoConferida:
    'A conferência das etapas não rodou agora, e nada é liberado até ela rodar. Tente de novo em instantes.',
  resumo: {
    liberadas: 'Etapas executadas liberadas',
    pendente: 'Pendência em {etapa}',
  },
  resumoLiberadas: 'Nenhuma etapa executada está a corrigir ou travada.',
  colunas: {
    etapa: 'Etapa',
    conferencia: 'Conferência da saída',
    liberacao: 'Liberação',
  },
  etapa: {
    recebimento: 'Recebimento e preservação',
    extracao: 'Extração e cobertura',
    analise: 'Análise e documentos',
    resultado: 'Resultado auditado',
    revisao: 'Revisão do perito',
    composicao: 'Composição dos documentos',
    assinatura: 'Assinatura',
    entrega: 'Entrega e aviso',
  },
  liberacao: {
    aprovado: 'Aprovado',
    corrigir: 'Corrigir',
    bloqueado: 'Bloqueado',
    aguardando: 'Aguardando',
  },
  aguardando: {
    etapa_anterior: 'Aguarda a etapa {etapa}.',
    nao_executada: 'Ainda não executada.',
  },
  aprovada: '{n} critério(s) conferido(s); nenhum crítico pendente.',
  criterio: {
    custodia_do_material: 'Custódia do material',
    recebimentos_selados: 'Recebimentos selados',
    leitura_conferida: 'Leitura conferida',
    pecas_verificadas: 'Peças verificadas',
    entradas_de_hoje: 'Material de agora',
    regua_vigente: 'Régua vigente',
    verificacoes_alinhadas: 'Verificações alinhadas',
    material_preservado: 'Material preservado',
    consultas_do_sistema: 'Consultas do sistema',
    avaliacao_de_hoje: 'Avaliação sobre o material de agora',
    veracidade_aprovada: 'Conferência de veracidade',
    conclusao_proposta: 'Conclusão da formalização',
    conclusao_do_perito: 'Conclusão do perito',
    conclusao_sobre_a_analise_vigente: 'Conclusão sobre a análise vigente',
    composta_da_etapa_vigente: 'Documento da etapa vigente',
    assinatura_registrada: 'Assinatura registrada',
    assinatura_com_certificado: 'Assinatura com certificado ICP-Brasil',
    emissao_confere: 'Arquivo assinado confere',
    assinada_sobre_a_revisao_vigente: 'Assinada sobre a revisão vigente',
    entregue_com_assinatura: 'Entregue com assinatura',
    aviso_da_entrega: 'Aviso da entrega',
  },
  resultado: {
    passou: 'Passou',
    falhou: 'Falhou',
    inconclusivo: 'Inconclusivo',
    nao_se_aplica: 'Não se aplica',
  },
  critico: 'crítico',
  informativo: 'informativo',
  fundamento: {
    material_conferido: 'Material recebido conferido pela custódia.',
    ocorrencia_aberta: 'Ocorrência de custódia aberta sobre uma peça.',
    recebimentos_selados: 'Recebimentos selados.',
    selado_na_emissao: 'Recebimento ainda aberto; ele é selado na emissão.',
    leitura_aprovada: 'Leitura conferida e aprovada.',
    leitura_em_retomada: 'Leitura em recuperação pelo sistema.',
    leitura_bloqueada: 'Falha técnica da leitura aguarda a equipe.',
    conferencia_pendente: 'A conferência da leitura ainda não saiu.',
    caso_sem_ficha: 'Caso sem leitura a conferir.',
    pecas_verificadas: 'Todas as peças verificadas.',
    peca_sem_verificacao: 'Peça ainda não verificada.',
    pecas_em_dia: 'Peças em aberto verificadas sobre o material de agora.',
    pecas_concluidas: 'Peças concluídas pelo perito; nada a refazer.',
    entradas_mudaram: 'O material da peça mudou depois da verificação.',
    regua_anterior: 'A peça foi verificada com uma régua anterior.',
    desalinhada: 'A verificação da peça não está alinhada com as demais.',
    material_preservado: 'Material preservado.',
    peca_parada_pela_custodia: 'Peça parada pela custódia.',
    retirada_do_exame: 'Peça retirada do exame.',
    consultas_respondidas: 'Consultas do sistema respondidas.',
    consulta_a_retomar: 'A consulta do sistema não respondeu; há nova tentativa.',
    orcamento_esgotado: 'A consulta do sistema não respondeu, e as tentativas acabaram.',
    avaliacao_sobre_as_entradas_de_hoje: 'Avaliação da formalização sobre o material de agora.',
    entradas_mudaram_desde_a_avaliacao: 'O material mudou depois da avaliação da formalização.',
    avaliacao_sem_impressao_do_fluxo:
      'A avaliação da formalização é anterior a esta conferência; a próxima leitura a refaz.',
    veracidade_aprovada: 'Conferência de veracidade aprovada.',
    veracidade_a_corrigir: 'A conferência de veracidade pede correção na avaliação.',
    veracidade_bloqueada: 'A conferência de veracidade bloqueou a avaliação.',
    conclusao_definida: 'Conclusão da formalização definida.',
    revisao_do_perito_pendente:
      'A conclusão da formalização aguarda a revisão do perito; não trava o consumo.',
    concluida_pelo_perito: 'Concluída pelo perito.',
    aguardando_o_perito: 'Aguarda a conclusão do perito.',
    apurada_pelo_motor: 'Conclusão apurada pelo sistema; a do perito é facultativa.',
    aguardando_a_verificacao: 'Aguarda a verificação do documento.',
    sobre_a_verificacao_lida: 'Conclusão sobre a verificação vigente.',
    verificada_depois_da_conclusao: 'A peça foi verificada de novo depois da conclusão.',
    composta_da_etapa_vigente: 'Documento composto da etapa vigente.',
    composta_de_rodada_anterior: 'Documento composto de uma rodada anterior.',
    assinada: 'Laudo assinado.',
    assinatura_com_certificado: 'Assinado com certificado digital ICP-Brasil.',
    assinatura_sem_certificado:
      'Assinatura registrada na plataforma, sem certificado ICP-Brasil: no exame eletrônico ela não é entregue ao cliente.',
    emissao_final_confere: 'O arquivo assinado confere com o emitido.',
    emissao_final_diverge: 'O arquivo assinado não confere com o emitido.',
    revisao_vigente: 'Assinado sobre a revisão vigente.',
    revisao_mudou_depois_da_assinatura: 'A revisão mudou depois da assinatura.',
    assinatura_anterior_a_conferencia: 'Assinatura anterior à conferência das etapas.',
    assinatura_sem_composicao_registrada: 'O laudo assinado não tem a composição registrada.',
    entregue_com_assinatura: 'Entregue com a assinatura aprovada.',
    entregue_sem_assinatura_aprovada: 'Entregue sem assinatura aprovada.',
    aviso_derivado_da_entrega: 'Aviso enviado a partir da entrega; não trava.',
  },
  limitadas: 'Limitação(ões) registrada(s): {n}.',
  semConfiguracao: 'Consulta(s) fora deste ambiente, já declarada(s) no documento: {n}.',
  condicao: {
    resolver_a_ocorrencia: 'Resolva a ocorrência de custódia da peça.',
    selar_o_recebimento: 'Sele o recebimento.',
    resolver_a_pendencia_da_leitura: 'Resolva a pendência na conferência da leitura, logo abaixo.',
    verificar_as_pecas: 'Verifique as peças do caso.',
    verificar_de_novo: 'Verifique o caso de novo.',
    avaliar_de_novo:
      'Abra a formalização na mesa: a avaliação é refeita sobre o material de agora.',
    corrigir_a_avaliacao: 'Corrija o que a conferência de veracidade apontou na avaliação.',
    revisar_na_mesa: 'Registre a revisão pendente na mesa.',
    tentar_de_novo_ou_registrar_limitacao: 'Tente a consulta de novo ou registre a limitação.',
    concluir_na_mesa: 'Conclua a peça na mesa.',
    reabrir_e_concluir: 'Reabra a peça na mesa e conclua de novo.',
    emitir_de_novo: 'Emita o documento de novo.',
    assinar: 'Assine o laudo na certificação.',
    conferir_o_arquivo_assinado: 'Confira o arquivo assinado.',
    conferir_a_revisao: 'Confira a revisão antes da assinatura.',
    conferir_a_assinatura: 'Confira a assinatura do laudo entregue.',
    conferir_a_entrega: 'Confira a entrega.',
    assinar_com_certificado:
      'No exame eletrônico, só o laudo assinado com certificado digital ICP-Brasil é entregue ao cliente.',
  },
  verCriterios: 'Ver os critérios ({n})',
  ocultarCriterios: 'Ocultar os critérios',
  versaoGravada: 'Versão {versao}, gravada em {quando}.',
  versaoDeOutraRodada:
    'A versão {versao} gravada é de outra rodada; a conferência de agora é gravada na próxima ação sobre o caso.',
  semVersao: 'Ainda sem versão gravada.',
  retrabalho:
    'Retrabalho: {versoes} versão(ões), {tentativas} tentativa(s), {limitacoes} limitação(ões).',
  espera: 'Aprovada {duracao} depois da primeira conferência.',
  duracao: {
    segundos: '{n} s',
    minutos: '{n} min',
    horas: '{n} h',
  },
  consultasTitulo: 'Resolver a pendência localizada',
  consultasTexto:
    'A consulta é do sistema, e a análise espera por ela. Responsável: equipe técnica. Nada é pedido ao banco.',
  consultaTitulo: 'Consulta indisponível: {consulta}',
  consultaARetomar: 'O sistema tenta de novo na próxima verificação, num número limitado de vezes.',
  consultaEsgotada: 'As tentativas automáticas acabaram: a análise fica travada até a equipe agir.',
  tentarConsulta: 'Tentar de novo',
  registrarLimitacao: 'Registrar limitação',
  justificativaRotulo: 'Por que a consulta não estava disponível no exame',
  justificativaAjuda:
    'De {min} a {max} caracteres. A justificativa fica registrada no caso, e a análise passa a declarar a limitação.',
  salvarLimitacao: 'Salvar limitação',
  cancelar: 'Cancelar',
  enviando: 'Enviando…',
  verificando: 'Verificando o caso…',
  pedidoFeito: {
    tentativa: 'Caso verificado de novo com a consulta. As etapas foram relidas.',
    limitacao: 'Limitação registrada. As etapas foram relidas.',
  },
  recusa: {
    sem_falha: 'Essa consulta já não trava a análise. As etapas foram relidas.',
    justificativa: 'Escreva a justificativa com {min} a {max} caracteres.',
    indisponivel: 'Não foi possível registrar agora. Tente novamente.',
  },
  acao: {
    mesa: 'Abrir a mesa',
    laudo: 'Abrir o laudo',
    certificacao: 'Ir para a certificação',
  },
  aguardaCertificador: 'A assinatura é feita pelo certificador da plataforma.',
} as const;
